import { jsx as _jsx } from "react/jsx-runtime";
import { Text as ChakraText, } from '@chakra-ui/react';
import { ThemeFontSizeVariable, ThemeFontVariable, } from '@caspeco/casper-ui-library.base-ui.theme';
/**
 * Used to render texts or paragraphs.
 *
 * @see Docs https://bit.cloud/caspeco/casper-ui-library/components/text
 */
export function Text({ as = 'p', fontFamily = ThemeFontVariable.Body, fontSize = ThemeFontSizeVariable.Medium, fontWeight = 'normal', color, children, ...props }) {
    return (_jsx(ChakraText, { as: as, fontFamily: fontFamily, fontSize: fontSize, color: color, fontWeight: fontWeight, ...props, children: children }));
}
//# sourceMappingURL=text.js.map